import { render, staticRenderFns } from "./EventsFilter.vue?vue&type=template&id=6fc3bf7e&scoped=true&"
import script from "./EventsFilter.vue?vue&type=script&lang=js&"
export * from "./EventsFilter.vue?vue&type=script&lang=js&"
import style0 from "./EventsFilter.vue?vue&type=style&index=0&id=6fc3bf7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc3bf7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VChip,VDialog,VDivider,VSelect,VSpacer})
